import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import { Button,Dialog,DialogContent,IconButton,Stack,Typography } from '@mui/material';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { UserContext } from '../../../context/UserContext';
import { trackEventMatomo } from '../../../helpers/matomo';

export default function RemoveModal({
  openRemove,
  setOpenRemove,
  mutate,
  nameRemove,
}: {
  openRemove: boolean,
  setOpenRemove: Function,
  mutate: Function,
  nameRemove: string,
}) {
  const { t } = useTranslation('translation');
  const { hierarchyLabel } = useContext(UserContext);

  const nameToRemove = () => {
    switch (nameRemove) {
      case 'local':
        return hierarchyLabel.local;
      case 'conjunto':
        return hierarchyLabel.conjunto;
      default: return (hierarchyLabel.unidade);
    }
  };

  return (
    <Dialog
      open={openRemove}
      onClose={() => setOpenRemove(false)}
      scroll={'paper'}
      fullWidth
      maxWidth='sm'
    >
      <IconButton
        aria-label="close"
        onClick={() => setOpenRemove(false)}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers={true}>
        <Stack direction='column' width='100%' justifyContent='center' alignItems='center' spacing={2}>
          <Typography color='textDisabled' fontWeight={600}>
            {`${t('Managements.remove')} ${nameToRemove()}?`}
          </Typography>
          <Button
            endIcon={<DeleteIcon />}
            className='button is-danger'
            onClick={() => {
              trackEventMatomo('Modal excluir local', 'click', 'button', 'salva');
              mutate();
            }}>
            {t('delete')}
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
